import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faGear } from '@fortawesome/free-solid-svg-icons';

const SCAN_W = 400;
const SCAN_H = 100;

export default function BarcodeScannerCore({
  videoRef,
  videoDevices,
  selectedDeviceId,
  onSelectDevice,
  onClose,
  beepRef
}) {
  const [showSettings, setShowSettings] = useState(false);

  const handleToggleSettings = () => {
    setShowSettings(prev => !prev);
  };
  const handleSelect = (e) => {
    onSelectDevice({ target: { value: e.target.value } });
    setShowSettings(false); // ✅ immediately hide settings
  };


  return (
    <div className="scanner-container">
      <video ref={videoRef} className="scanner-video" autoPlay muted playsInline />

      {/* Dim background when settings are open */}
      {showSettings && <div className="dim-overlay" />}

      {/* ROI Box & Scan Line */}
      {!showSettings && (
        <div className="scanner-roi-box">
          <div className="scan-line" />
        </div>
      )}

      {/* Camera Settings Panel */}
      {showSettings &&
        ReactDOM.createPortal(
          <div className="camera-settings slide-in">
            <button onClick={handleToggleSettings} className="settings-close-button">
              <FontAwesomeIcon icon={faXmark} />
            </button>
            <label className="text-white mb-2">Camera</label>
            {videoDevices.map(dev => (
              <button
                key={dev.deviceId}
                className={`btn btn-outline-light w-100 mb-2 ${dev.deviceId === selectedDeviceId ? 'active' : ''}`}
                onClick={handleSelect}
                value={dev.deviceId}
              >
                {dev.label}
              </button>
            ))}

          </div>,
          document.getElementById('scanner-settings-root')
        )}

      {/* UI Buttons */}
      <button className="close-button" onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} />
      </button>
      <button className="settings-toggle-button" onClick={handleToggleSettings}>
        <FontAwesomeIcon icon={faGear} />
      </button>

      {/* Styles */}
      <style jsx>{`
        .scanner-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 9999;
          pointer-events: auto;
        }
        .scanner-video {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
          pointer-events: none;
        }
        .dim-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 2;
        }
        .scanner-roi-box {
          position: absolute;
          top: 40%;
          left: 5%;
          width: 90%;
          height: 20%;
          border: 2px solid #00ff99;
          box-shadow: 0 0 10px #00ff99;
          z-index: 3;
        }
        .scan-line {
          position: absolute;
          top: 50%;
          width: 100%;
          height: 2px;
          background: red;
          transform: translateY(-50%);
        }
        .close-button,
        .settings-toggle-button,
        .settings-close-button {
          position: absolute;
          top: 20px;
          background: rgba(0, 0, 0, 0.6);
          border: none;
          color: white;
          font-size: 1.5rem;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          z-index: 10000;
          pointer-events: auto;
        }
        .close-button {
          right: 20px;
        }
        .settings-toggle-button {
          right: 70px;
        }
        .settings-close-button {
          position: absolute;
          top: -15px;
          right: -15px;
          background: #000;
          border: none;
          color: white;
          font-size: 1.2rem;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          z-index: 10001;
          box-shadow: 0 0 5px rgba(0,0,0,0.3);
        }


        .camera-settings {
          position: fixed;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          background: #212529;
          padding: 20px;
          border-radius: 10px;
          z-index: 2147483647;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
          width: 300px;
          pointer-events: auto;
          opacity: 0;
          transform: translateX(-50%) translateY(20px);
          animation: slideUp 0.3s ease-out forwards;
        }

        @keyframes slideUp {
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        .camera-settings button.active {
          background-color: #0d6efd;
          color: white;
          border-color: #0d6efd;
        }
      `}</style>
    </div>
  );
}
